import { Component, OnInit, ViewEncapsulation, Output, Input, EventEmitter } from '@angular/core';
//import { EmployeeService } from '../../../shared/services/employee.service';
import {
    AccountDetails,
    ClientIdentifier,
    ClientIdentifierUpdate,
    ClientInformationInterface,
} from '../../../shared/interfaces/client-data';
import { ToastService } from '../../../shared/services/toast.service';
import { ClientsService } from '../../../shared/services/clients.service';
import { UserService } from '../../../shared/services/user.service';
import { ImpersonationService } from '../../../shared/services/impersonation.service';
import { ReusableFunctions } from '../../../shared/classes/reusable-functions';
import { ClientContactsService } from '../../services/client-contacts.service';
import { forkJoin } from 'rxjs';
import {
    UntypedFormGroup,
    UntypedFormBuilder,
    UntypedFormControl,
    Validators,
    UntypedFormArray,
} from '@angular/forms';
import { IntegrationSourceService } from '../../services/integration-source.service';
import {
    ClientSubscriptionService,
    ClientSubscriptionType,
} from '../../services/client-subscription.service';
import { CurrentUserStateService } from '../../../shared/services/current-user-state.service';

@Component({
    selector: 'app-company-account-details',
    templateUrl: './company-account-details.component.html',
    styleUrls: ['./company-account-details.component.scss'],
})
export class CompanyAccountDetailsComponent implements OnInit {
    // for if coming in from lba-clients view
    @Input() selectedCompanyDetails: AccountDetails;
    @Input() companyFullModel: ClientInformationInterface;
    @Input() editing: boolean;
    @Input() addEditOrViewOnly: string;
    @Output() cancelClickedEvent = new EventEmitter();
    @Output() companyModEvent = new EventEmitter();
    fromClient: boolean;
    leiIds: ClientIdentifier;
    nmlsIds: ClientIdentifier;
    clientFullInfo: ClientInformationInterface;
    accountDetails: AccountDetails;
    subscriptionTypeList: ClientSubscriptionType[];
    savingData: boolean;
    isMainMenuQuickOpen = false;
    clientShortName: string;
    dataReady: boolean;

    tabs = [{ label: 'Company Info' }, { label: 'Contacts' }, { label: 'Systems & Integrations' }];
    tabActiveIndex: number;
    editMenuTitle: string;
    editingMain: boolean = false;
    isEditMenuOpen: boolean;
    isEditing: boolean;
    isAdding: boolean;
    addOrEditClientForm: UntypedFormGroup;
    isLBA: boolean = true;
    isSuperUser: boolean;
    isSuperAdmin: boolean;
    // identifier variables
    clientHmdaIdentities: ClientIdentifier[];
    clientNmlsIdentities: ClientIdentifier[];
    compenSafeIdentifiers: ClientIdentifier[];
    hubSpotIdentifiers: ClientIdentifier[];
    companyIdentityForm: UntypedFormGroup;
    hmdaIdentityForm: UntypedFormGroup;
    nmlsIdentityForm: UntypedFormGroup;
    hmdaIsEditing: boolean = false;
    nmlsIsEditing: boolean = false;

    constructor(
        private integrationSourceService: IntegrationSourceService,
        private clientSubscriptionService: ClientSubscriptionService,
        private clientContactsService: ClientContactsService,
        private clientService: ClientsService,
        private currentUserStateService: CurrentUserStateService,
        private impersonationService: ImpersonationService,
        private toastService: ToastService,
        private reusableFunctions: ReusableFunctions,
        private formBuilder: UntypedFormBuilder
    ) {}
    ngOnInit() {
        this.dataReady = false;
        this.editingMain = false;
        this.tabActiveIndex = 0;
        // if view not passed in then set it
        if (!this.addEditOrViewOnly) {
            this.addEditOrViewOnly = 'viewOnly';
        }
        this.isEditMenuOpen = false;
        this.editMenuTitle = '';
        this.isEditing = false;
        this.isAdding = false;
        this.addOrEditClientForm = this.createFormGroup();
        let clientShortName = this.currentUserStateService.currentUser.clientShortName;
        if (clientShortName === 'LBA' && !this.impersonationService.isImpersonatingClient()) {
            return;
        }
        if (this.impersonationService.isImpersonatingClient()) {
            clientShortName = this.impersonationService.impersonateClient;
        }

        if (
            this.currentUserStateService.isLBASuperUser() &&
            !this.impersonationService.isImpersonatingUser()
        ) {
            this.isSuperAdmin = true;
        }
        this.clientShortName = clientShortName;
        if (this.companyFullModel) {
            this.fromClient = true;
            this.clientShortName = this.companyFullModel.clientDetails.shortName;
        }
        if (!this.companyFullModel) {
            this.fromClient = false;
            this.companyFullModel = this.getFullModelForClient(clientShortName);
        }
        this.createIdentityForms();
        this.dataReady = true;
    }
    // account details - tab 1
    getAccountDetails(): void {
        this.clientService.getAccountDetails(this.clientShortName).subscribe((data) => {
            this.accountDetails = data;
        });
    }
    getSubscriptionTypes() {
        this.clientSubscriptionService.getSubscriptionTypes().subscribe((data) => {
            this.subscriptionTypeList = data;
        });
    }
    createFormGroup(): UntypedFormGroup {
        return this.formBuilder.group({
            fullName: new UntypedFormControl(this.companyFullModel.clientDetails.fullName, [
                Validators.required,
                Validators.maxLength(100),
            ]),
            hubspotUrl: new UntypedFormControl(
                this.companyFullModel.clientDetails.hubSpotUrl,
                Validators.maxLength(150)
            ),
            companyUrl: new UntypedFormControl(
                this.companyFullModel.clientDetails.companyURL,
                Validators.maxLength(200)
            ),
            compenSafeUrl: new UntypedFormControl(
                this.companyFullModel.clientDetails.compenSafeUrl,
                Validators.maxLength(200)
            ),
            subscriptionType: new UntypedFormControl(
                this.companyFullModel.clientDetails.subscriptionType
            ),
        });
    }
    logForm() {
        console.log(this.addOrEditClientForm);
        this.editingMain = false;
    }
    get fullName() {
        return this.addOrEditClientForm.get('fullName');
    }
    get hubspotUrl() {
        return this.addOrEditClientForm.get('hubspotUrl');
    }
    get compenSafeUrl() {
        return this.addOrEditClientForm.get('compenSafeUrl');
    }
    get subscriptionType() {
        return this.addOrEditClientForm.get('subscriptionType');
    }

    // cancel edit client info
    cancel() {
        this.editingMain = false;
        this.isEditMenuOpen = false;
        this.isEditing = false;
        this.isAdding = false;
        this.addOrEditClientForm.reset();
    }
    // edit client info
    edit() {
        this.isEditing = true;
        this.isAdding = false;
        this.isEditMenuOpen = true;
        this.editingMain = false;
    }
    editBasicForm() {
        this.editingMain = true;
    }
    // update client information
    updateClient() {
        this.savingData = true;
        this.editingMain = false;
        this.logForm();
    }
    // go back to client list
    cancelClicked() {
        this.cancelClickedEvent.emit();
    }
    showContact: boolean;
    tabChangeHandler(index: number) {
        this.tabActiveIndex = index;
    }
    // if return true, changes were made
    updatePageFromSideBar(event) {
        const result = event.formResult;
        this.isEditMenuOpen = false;
        this.isEditing = false;
        this.isAdding = false;
        if (result == true) {
            this.getAccountDetails();
        }
    }
    checkClientHasCompenSafe(data: ClientIdentifier[]): boolean {
        var comp = data.find((c) => c.identifierType == 'CompenSafe');
        return comp != null;
    }
    // for if not navigating to here from client list
    getFullModelForClient(shortName: string): ClientInformationInterface {
        var data: ClientInformationInterface;
        forkJoin(
            this.clientService.getAccountDetails(shortName),
            this.clientContactsService.getContactsByName(shortName),
            this.clientService.getClientIdentifierRecords(shortName),
            this.integrationSourceService.getClientIntegrationSourcesByName(shortName)
        ).subscribe(([details, contacts, identifiers, clientIntegrationSources]) => {
            this.companyFullModel.clientDetails = details;
            this.companyFullModel.contacts = contacts;
            this.companyFullModel.identifiers = identifiers;
            this.companyFullModel.clientIntegrationSources = clientIntegrationSources;
            this.leiIds = data.identifiers.find((x) => x.identifierType == 'LEI');
            this.nmlsIds = data.identifiers.find((x) => x.identifierType == 'NMLS');
            this.clientShortName = this.companyFullModel.clientDetails.shortName;
            this.dataReady = true;
            return data;
        });
        return data;
    }

    // Functions for Identifier Form
    editIdentities(type: string) {
        if (type == 'HMDA') {
            this.hmdaIsEditing = true;
            this.hmdaIdentityForm.enable();
        }
        if (type == 'NMLS') {
            this.nmlsIsEditing = true;
            this.nmlsIdentityForm.enable();
        }
    }
    cancelEditedIdentities(type: string) {
        if (type == 'HMDA') {
            this.hmdaIsEditing = false;
            this.hmdaIdentityForm.disable();
        }
        if (type == 'NMLS') {
            this.nmlsIsEditing = false;
            this.nmlsIdentityForm.disable();
        }
    }
    createIdentityForms() {
        this.hmdaIdentityForm = this.createHmdaIdentityForm();
        this.nmlsIdentityForm = this.createNmlsIdentityForm();
        this.populateIdentityControls();
    }
    createHmdaIdentityForm(): UntypedFormGroup {
        return this.formBuilder.group({
            hmdaIdentityControlsArray: this.formBuilder.array([this.createIdentityGroup()]),
        });
    }
    createNmlsIdentityForm(): UntypedFormGroup {
        return this.formBuilder.group({
            nmlsIdentityControlsArray: this.formBuilder.array([this.createIdentityGroup()]),
        });
    }
    createIdentityGroup(id?: any): UntypedFormGroup {
        if (id) {
            return this.formBuilder.group({
                identifier: new UntypedFormControl(id.identifier, Validators.required),
                activeDate: new UntypedFormControl(id.activeDate, Validators.required),
                inActiveDate: new UntypedFormControl(id.inActiveDate, Validators.required),
                isNew: new UntypedFormControl(false),
                setDeleted: new UntypedFormControl(false),
            });
        } else {
            return this.formBuilder.group({
                identifier: new UntypedFormControl('', Validators.required),
                activeDate: new UntypedFormControl(new Date('1/1/1900'), Validators.required),
                inActiveDate: new UntypedFormControl(new Date('12/31/9999'), Validators.required),
                isNew: new UntypedFormControl(true),
                setDeleted: new UntypedFormControl(false),
            });
        }
    }
    getThisIsIsNewControl(type: string, index: number) {
        if (type == 'HMDA') return this.hmdaIdentityControlsArray[index].get('isNew');
        if (type == 'NMLS') return this.nmlsIdentityControlsArray[index].get('isNew');
    }
    getThisIdSetDeletedControl(type: string, index: number) {
        if (type == 'HMDA') return this.hmdaIdentityControlsArray[index].get('setDeleted');
        if (type == 'NMLS') return this.nmlsIdentityControlsArray[index].get('setDeleted');
    }
    getThisIdIdentityControl(type: string, index: number) {
        if (type == 'HMDA') return this.hmdaIdentityControlsArray[index].get('identifier');
        if (type == 'NMLS') return this.nmlsIdentityControlsArray[index].get('identifier');
    }
    getThisIdActiveDateControl(type: string, index: number) {
        if (type == 'HMDA') return this.hmdaIdentityControlsArray[index].get('activeDate');
        if (type == 'NMLS') return this.nmlsIdentityControlsArray[index].get('activeDate');
    }
    getThisIdInActiveDateControl(type: string, index: number) {
        if (type == 'HMDA') return this.hmdaIdentityControlsArray[index].get('inActiveDate');
        if (type == 'NMLS') return this.nmlsIdentityControlsArray[index].get('inActiveDate');
    }
    get hmdaIdentityControlsArray() {
        return (<UntypedFormArray>this.hmdaIdentityForm.get('hmdaIdentityControlsArray')).controls;
    }
    get nmlsIdentityControlsArray() {
        return (<UntypedFormArray>this.nmlsIdentityForm.get('nmlsIdentityControlsArray')).controls;
    }
    // insert blank identity
    addBlankIdentity(type: string) {
        type = type.toUpperCase();
        if (type == 'HMDA') {
            (this.hmdaIdentityForm.controls.hmdaIdentityControlsArray as UntypedFormArray).push(
                this.createIdentityGroup()
            );
            this.hmdaIsEditing = true;
            this.editIdentities('HMDA');
        }
        if (type == 'NMLS') {
            (this.nmlsIdentityForm.controls.nmlsIdentityControlsArray as UntypedFormArray).push(
                this.createIdentityGroup()
            );
            this.editIdentities('NMLS');
        }
    }
    // set identity for removal
    removeIdentity(type: string, index: number) {
        type = type.toUpperCase();
        if (type == 'HMDA') {
            if (
                (this.hmdaIdentityForm.controls.hmdaIdentityControlsArray as UntypedFormArray)[
                    index
                ].get('isNew') == true
            ) {
                (
                    this.hmdaIdentityForm.controls.hmdaIdentityControlsArray as UntypedFormArray
                ).removeAt(index);
            } else {
                (this.hmdaIdentityForm.controls.hmdaIdentityControlsArray as UntypedFormArray)[
                    index
                ].disable();
                (this.hmdaIdentityForm.controls.hmdaIdentityControlsArray as UntypedFormArray)[
                    index
                ]
                    .get('setDelete')
                    .setValue(true);
            }
        }
        if (type == 'NMLS') {
            if (
                (this.nmlsIdentityForm.controls.nmlsIdentityControlsArray as UntypedFormArray)[
                    index
                ].get('isNew') == true
            ) {
                (
                    this.nmlsIdentityForm.controls.nmlsIdentityControlsArray as UntypedFormArray
                ).removeAt(index);
            } else {
                (this.nmlsIdentityForm.controls.nmlsIdentityControlsArray as UntypedFormArray)[
                    index
                ].disable();
                (this.nmlsIdentityForm.controls.nmlsIdentityControlsArray as UntypedFormArray)[
                    index
                ]
                    .get('setDelete')
                    .setValue(true);
            }
        }
    }
    // submit identities for update/insert/removal
    submitIdentityForm(type: string) {
        let shortName = this.clientShortName;
        if (this.companyFullModel) shortName = this.companyFullModel.clientDetails.shortName;
        if (type == 'HMDA') {
            this.hmdaIdentityControlsArray.forEach((id, index) => {
                // delete
                if (this.getThisIdSetDeletedControl('HMDA', index).value) {
                    this.clientService
                        .deleteClientIdentifier(this.clientHmdaIdentities[index], shortName)
                        .subscribe(
                            () => {
                                this.toastService.success('Identity deleted.');
                                (
                                    this.hmdaIdentityForm.controls
                                        .hmdaIdentityControlsArray as UntypedFormArray
                                ).removeAt(index);
                            },
                            () => {
                                this.toastService.warning('Identity could not be deleted.');
                            }
                        );
                } else if (this.getThisIsIsNewControl('HMDA', index).value) {
                    // new
                    let c: ClientIdentifier = {} as ClientIdentifier;
                    c.identifier = this.getThisIdIdentityControl('HMDA', index).value;
                    c.identifierType = 'LEI';
                    this.clientService.insertClientIdentifier(c, shortName).subscribe(
                        () => {
                            this.toastService.success('Identity added.');
                        },
                        () => {
                            this.toastService.warning('Identity could not be added.');
                        }
                    );
                } else {
                    // update
                    let c: ClientIdentifierUpdate = {} as ClientIdentifierUpdate;
                    c.identifier = this.getThisIdIdentityControl('HMDA', index).value;
                    c.activeDate = this.getThisIdActiveDateControl('HMDA', index).value;
                    c.inActiveDate = this.getThisIdInActiveDateControl('HMDA', index).value;
                    c.identifierOld = this.clientHmdaIdentities[index].identifier;
                    c.identifierType = 'LEI';
                    this.clientService.updateClientIdentifier(c, shortName).subscribe(
                        () => {
                            this.toastService.success('Identity updated.');
                        },
                        () => {
                            this.toastService.warning('Identity could not be deleted.');
                        }
                    );
                }
            });
            this.hmdaIsEditing = false;
            this.hmdaIdentityForm.disable();
        }
        if (type == 'NMLS') {
            this.nmlsIdentityControlsArray.forEach((id, index) => {
                // delete
                if (this.getThisIdSetDeletedControl('NMLS', index).value) {
                    this.clientService
                        .deleteClientIdentifier(this.clientNmlsIdentities[index], shortName)
                        .subscribe(
                            () => {
                                this.toastService.success('Identity deleted.');
                                (
                                    this.nmlsIdentityForm.controls
                                        .nmlsIdentityControlsArray as UntypedFormArray
                                ).removeAt(index);
                            },
                            () => {
                                this.toastService.warning('Identity could not be deleted.');
                            }
                        );
                } else if (this.getThisIsIsNewControl('NMLS', index).value) {
                    // new
                    let c: ClientIdentifier = {} as ClientIdentifier;
                    c.identifier = this.getThisIdIdentityControl('NMLS', index).value;
                    c.identifierType = 'NMLS';
                    this.clientService.insertClientIdentifier(c, shortName).subscribe(
                        () => {
                            this.toastService.success('Identity added.');
                        },
                        () => {
                            this.toastService.warning('Identity could not be added.');
                        }
                    );
                } else {
                    // update
                    let c: ClientIdentifierUpdate = {} as ClientIdentifierUpdate;
                    c.identifier = this.getThisIdIdentityControl('NMLS', index).value;
                    c.activeDate = this.getThisIdActiveDateControl('NMLS', index).value;
                    c.inActiveDate = this.getThisIdInActiveDateControl('NMLS', index).value;
                    c.identifierOld = this.clientNmlsIdentities[index].identifier;
                    c.identifierType = 'NMLS';
                    c.isActive = true;
                    this.clientService.updateClientIdentifier(c, shortName).subscribe(
                        () => {
                            this.toastService.success('Identity updated.');
                        },
                        () => {
                            this.toastService.warning('Identity could not be deleted.');
                        }
                    );
                }
            });
            this.nmlsIsEditing = false;
            this.nmlsIdentityForm.disable();
        }
    }
    // populate identity variables
    populateIdentityControls() {
        // setup arrays and clear forms
        this.clientHmdaIdentities = [];
        this.clientNmlsIdentities = [];
        this.compenSafeIdentifiers = [];
        this.hubSpotIdentifiers = [];
        (this.hmdaIdentityForm.controls.hmdaIdentityControlsArray as UntypedFormArray).clear();
        (this.nmlsIdentityForm.controls.nmlsIdentityControlsArray as UntypedFormArray).clear();
        // populate emptied arrays and form arrays
        if (this.companyFullModel) {
            this.companyFullModel.identifiers.forEach((id) => {
                const grp = this.formBuilder.group({
                    identifier: new UntypedFormControl(id.identifier, Validators.required),
                    isNew: new UntypedFormControl(false),
                });
                if (id.identifierType == 'LEI') {
                    this.clientHmdaIdentities.push(id);
                    (
                        this.hmdaIdentityForm.controls.hmdaIdentityControlsArray as UntypedFormArray
                    ).push(grp);
                } else if (id.identifierType == 'NMLS') {
                    this.clientNmlsIdentities.push(id);
                    (
                        this.nmlsIdentityForm.controls.nmlsIdentityControlsArray as UntypedFormArray
                    ).push(grp);
                } else if (id.identifierType == 'HubSpot') {
                    this.hubSpotIdentifiers.push(id);
                } else if (id.identifierType == 'CompenSafe') {
                    this.compenSafeIdentifiers.push(id);
                } else {
                    console.log(
                        'Identifier type not defined: ' + id.identifierType + ' ' + id.identifier
                    );
                }
            });
            this.nmlsIdentityForm.disable();
            this.hmdaIdentityForm.disable();
        }
    }
}
